export default {
	"问卷导航": "問卷導航",
	"第": '第',
	'页': "頁",
	"本页自定义逻辑编辑": '本頁自訂邏輯編輯',
	"页头": '頁頭',
	"产品": '產品',
	"页尾": '頁尾',
	"提示": '提示',
	"当前桌号": '當前桌號',
	"位置信息": '位置資訊',
	"选择日期": '選擇日期',
	"选择时间": '選擇時間',
	"秒": '秒',
	"数据将不会被保存": '注:現在是問卷測試模式，資料將不會被保存',
	"清除测试数据重新开始": '清除測試資料重新開始',
	"问卷页": '問卷頁',
	"非常不": '非常不',
	"非常": '非常',
	"文字作答": '文字作答',
	"语音作答": '語音作答',
	"总体喜欢度": '總體喜歡度',
	"肯定购买": '肯定購買',
	"关键指标3": '關鍵指標3',
	"设置": '設置',
	"性别": '性別',
	"年龄": '年齡',
	"城市": '城市',
	"产品": '產品',
	"开放题": '開放題',
	'当前题号': '當前題號',
	"本题自定义逻辑编辑": '本題自定義邏輯編輯',
	"高级设置": '高級設置',
	"每一行代表一个问题答案": '每一行代表一個問題/答案',
	"制表符": '定位字元',
	"覆盖选项": '覆蓋選項',
	"追加选项": '追加選項',
	"分隔符": '分隔符',
	"无分隔符": '無分隔符',
	"空格": '空格',
	"逗号": '逗號',
	"值在后": '值在後',
	"选项互斥": '選項互斥',
	"一行显示个数": '一行顯示個數',
	"随机选项": '隨即選項',
	"实例": '實例',
	"表示值随机": '表示值為1,2,3的選項隨機，用英文逗號隔開',
	"不随机选项": '不隨機選項',
	"表示值不随机": '表示值為1,2,3的選項不隨機，用英文逗號隔開',
	"表示选项互斥": "表示選項1或2和選項3或4和選項5或6或7只能被選中一組（個），其中1234567都為選項的值",
	"全部随机": '全部隨機',
	"转置": '轉置',
	"使用下拉菜单": '使用下拉式功能表',
	"若使用下拉菜单则选项的半开放不生效": '注意：若使用下拉式功能表則選項的半開放不生效',
	"答案校验": '答案校驗',
	"答案不验证": '答案不校驗',
	"答案验证为数字": '答案驗證為數字',
	"答案验证为日期": '答案驗證為日期',
	"最小值": '最小值',
	"最大值": '最大值',
	"值":'值',
	"唯一性": '唯一性',
	"该答案在本项目唯一": '該答案在本項目唯一',
	"选项倒序": '選項倒序',
	"逐一呈现": '逐一呈現',
	"随机问题": '隨機問題',
	"超时记0": '超時記0（否則按實際點擊用時記錄）',
	"答案设置": '答案設置',
	"排序个数": '排序個數',
	"最小排序数": '最小排序數',
	"最大排序数": '最大排序數',
	"最多上传数量": '最多上傳數量',
	"最少上传数量": '最少上傳數量',
	"拍照上传": '拍照上傳',
	"是否为视频": '是否爲視頻',
	"是否为图片": '是否爲圖片',
	"是否允许语音作答": '是否允許語音作答',
	"选项":'選項',
	"批量编辑修改":'批量編輯/修改',
	"列问题":'列問題',
	"行问题":'行問題',
	"问题":'問題',
	"半开放":'半開放',
	"收藏到题库":'收藏到題庫',
	"划线内容":'劃綫内容',
	"不可选":'不可選',
	"行问题随机":'行問題隨機',
	"答案必须是数字":'答案必須是數位',
	"问题管理":'問題管理',
	"问卷管理":'問卷管理',
	"点击获取定位":'點擊獲取定位',
	"量表类型":'量表類型',
	"类型名称":'類型名稱',
	"选择数量":'選擇數量',
	"量表样式":'量表樣式',
	"同一个设备只能填一次":'同一個設備只能填一次',
	"不能为空":'不能爲空',
	"设置桌号":'設置桌號',
	"开始":'開始',
	"当前桌号":'當前桌號',
	"有误":'有誤',
  "选择日期":'選擇日期',
  "选择时间":'選擇時間',
  "全部":'全部',
	"起始数值":'起始數值',
	"不显示数值":'不顯示數值',
  "显示雷达图":'顯示雷達圖',
  "冻结题目":'凍結題目',
  "您已参与过该项目请勿重复参与":'您已參與過該項目，請勿重複參與',
  "上传图片":'上傳圖片',
  "冻结选项":'凍結選項'

}